import 'components/hands/css/Player.css';

const Player = ({ position, stack, setStackSizes, readOnly = false }) => {
  return (
    <div className="player-container">
      <div className="player-content">
        <div className="player-position">
          {position}
        </div>
        <div className="player-stack-section">
          <div className="player-stack-label">Stack</div>
          <div className="player-stack-amount">
            ${stack}
          </div>
          {!readOnly && (
            <input
              type="number"
              value={stack}
              onChange={(e) => setStackSizes(parseInt(e.target.value) || 0)}
              className="player-stack-input"
              placeholder="Stack size"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Player;
